import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kve-top-center',
  templateUrl: './top-center.component.html',
  styleUrls: ['./top-center.component.scss']
})
export class TopCenterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
